import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleHeading1, InlineText1, InlineText2 } from '@cian/ui-kit';
import { News as NewsComponent } from '../../components/News';
import { getNews } from '../../selectors';
import { NewsCard } from '../../components/NewsCard';

export function News() {
  const news = useSelector(getNews);
  const newsCards = React.useMemo(
    () =>
      news.map(card => (
        <NewsCard
          key={card.id}
          title={<InlineText1>{card.title}</InlineText1>}
          date={<InlineText2 color="gray60_100">{card.date}</InlineText2>}
        />
      )),
    [news],
  );

  if (!newsCards.length) {
    return null;
  }

  return <NewsComponent title={<ArticleHeading1>Новости</ArticleHeading1>} news={newsCards} />;
}
